export default __webpack_public_path__ + "static/scyrg-4-46898324c9ebc0b077c0e773299d33cc.png";